import {Checkbox} from '@mantine/core'
import React, {useState} from 'react'
import {intersectionArrays} from '@appscience/utils'
import {PopupDefaultContent, getPopupDefaultButtons} from '@appscience/popups'
import {ManageColumnType} from '../../model'

interface ColumnInfo {
  id: string,
  title: React.ReactNode,
  manageType?: ManageColumnType,
}

interface VisibleColumnsPopupProps {
  columns: Array<ColumnInfo>,
  selectedIds?: Array<string>,
  onSave: (ids: Array<string>) => void,
  closeFn: () => void,
}

export function VisibleColumnsPopup(props: VisibleColumnsPopupProps) {
  return <PopupDefaultContent
    title='Отображаемые колонки'
    createContent={() => <Content {...props} />}
    closeFn={props.closeFn}
  />
}

function Content({
  columns: allColumns,
  selectedIds = [],
  onSave,
  closeFn,
}: VisibleColumnsPopupProps) {
  const columns = allColumns.filter(x => x.manageType !== 'hidden')
  const [selectedColumnIds, toggle] = useCheckState(
    intersectionArrays(selectedIds, columns.map(x => x.id)),
  )

  function onSuccess() {
    onSave(selectedColumnIds)
    closeFn()
  }

  return (
    <div>
      {columns.length > 0 && (
        <div className='grid gap-x-4 items-center grid-cols-2 mb-2'>
          {columns.map(x => (
            <Checkbox
              key={x.id}
              label={x.title}
              name={x.id}
              checked={selectedColumnIds.includes(x.id)}
              onChange={() => toggle(x.id)}
              className='px-3 py-2 duration-200'
              disabled={x.manageType === 'disabled'}
            />
          ))}
        </div>
      )}
      <div className='flex justify-end mt-3 space-x-2'>
        {getPopupDefaultButtons({
          success: { onClick: onSuccess },
          cancel: { onClick: closeFn },
        })}
      </div>
    </div>
  )
}

function useCheckState<T extends string>(initValue?: Array<T>, onChange?: (ids: Array<T>) => void): [Array<T>, (id: T) => void] {
  const [state, setState] = useState<Array<T>>(initValue || [])
  function toggle(id: T) {
    const newState = state.includes(id) ? state.filter(x => x !== id) : state.concat(id)
    setState(newState)
    onChange && onChange(newState)
  }
  
  return [state, toggle]
}